import { CarriersEnum, SCACEnum } from '@app/app.enum';
import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';
import * as _ from 'lodash';

@Injectable()
export class MetaDataService {
	private baseUrl = environment.apiGateway.apiUrl;
	private metaApiUrl = '';

	// Caches
	private carriers: models.ICarrier[] = [];

	constructor() {
		this.metaApiUrl = this.baseUrl + 'MetaData/';
	}

	public async getAllCountries(cancelToken?: CancelToken): Promise<models.ICountry[]> {
		try {
			const url = this.metaApiUrl + `Country`;
			const res = await axios.get<models.ICountry[]>(url, { cancelToken });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getStates(countryCode: string, cancelToken?: CancelToken): Promise<models.IState[]> {
		try {
			const url = this.metaApiUrl + `Country/${countryCode}/States`;
			const res = await axios.get<models.IState[]>(url, { cancelToken });
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getAllCarriers(scac?: SCACEnum, cancelToken?: CancelToken): Promise<models.ICarrier[]> {
		try {
			// Return from cache if available
			if (!_.isEmpty(this.carriers)) {
				return this.carriers;
			}

			const url = this.baseUrl + 'Carrier';
			const res = await axios.get<models.ICarrier[]>(url, {
				params: {
					scac,
				},
				cancelToken,
			});

			this.carriers = res.data;

			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getAllSCACs(cancelToken?: CancelToken): Promise<models.ICarrierSCAC[]> {
		try {
			const url = this.baseUrl + 'Carrier/SCAC';
			const res = await axios.get<models.ICarrierSCAC[]>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	public async getCarrierByCode(carrierCode: CarriersEnum, cancelToken?: CancelToken): Promise<models.ICarrier> {
		try {
			// Return from cache if available
			if (!_.isEmpty(this.carriers)) {
				const carrier = _.find(this.carriers, (x) => x.code === carrierCode);

				if (!_.isNil(carrier)) {
					return carrier;
				}
			}

			const url = this.baseUrl + 'Carrier/' + carrierCode;
			const res = await axios.get<models.ICarrier>(url, {
				cancelToken,
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/meta-data.service.ts